import { Directory, Encoding, FileInfo, Filesystem } from '@capacitor/filesystem';
import { FileSystemFileEntry } from 'ngx-file-drop';

export const getFile = (fileEntry: FileSystemFileEntry): Promise<File> => {
  return new Promise((resolve) => {
    fileEntry.file((file: File) => {
      resolve(file);
    });
  });
};

export const writeFSFile = async (path: string, data: string): Promise<void> => {
  console.log('writeFSFile', path, data.length);
  await Filesystem.writeFile({ path, data, directory: Directory.Data, encoding: Encoding.UTF8, recursive: true });
};

export const isFileExists = async (path: string): Promise<boolean> => {
  try {
    await Filesystem.stat({ path, directory: Directory.Data });
    return true;
  } catch (event) {
    return false;
  }
};

export const readFSFile = async (path: string): Promise<string> => {
  const content = await Filesystem.readFile({ path, directory: Directory.Data, encoding: Encoding.UTF8 });
  return content.data as string;
};

export const deleteFSFile = async (path: string): Promise<void> => {
  console.log(`Deleting filesystem file ${path}`);
  return Filesystem.deleteFile({ path, directory: Directory.Data }).catch((e) => console.error(`Could not find ${path}`, e));
};

export const deleteFSDirectory = async (path: string): Promise<void> => {
  console.log(`Deleting filesystem directory ${path}`);
  await Filesystem.rmdir({ path: path, recursive: true, directory: Directory.Data });
};

export const readFSFolder = async (path: string): Promise<FileInfo[]> => {
  try {
    const content = await Filesystem.readdir({ path, directory: Directory.Data });
    return content.files;
  } catch (e) {
    console.error(e);
    return [];
  }
};

export const getAllFSFiles = async (folderPath: string, filter: (f: FileInfo) => boolean = () => true): Promise<FileInfo[]> => {
  const files: FileInfo[] = [];

  const entries = await readFSFolder(folderPath);
  for (const entry of entries.filter(filter)) {
    const fullPath = `${folderPath}/${entry.name}`;
    if (entry.type === 'directory') {
      const subFiles = await getAllFSFiles(fullPath, filter);
      files.push(...subFiles);
    } else {
      files.push(entry);
    }
  }

  return files;
};

export const blobToBase64 = (blob: Blob): Promise<string> => {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result as string);
    reader.readAsDataURL(blob);
  });
};

const DATA_URL_MIME_PATTERN = /^data:(image\/[a-zA-Z0-9.+-]+);base64,/;

/** Image type announced by a base64 data URL prefix, `image/jpeg` when there is none (legacy files). */
export const getDataUrlImageType = (dataUrl: string): string => DATA_URL_MIME_PATTERN.exec(dataUrl)?.[1] ?? 'image/jpeg';
